import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    total: 0,
    draft: 0,
    pending: 0,
    approved: 0
  });
  const [recentOffers, setRecentOffers] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/offers');
      const offers = response.data.data;
      
      setStats({
        total: offers.length,
        draft: offers.filter(o => o.status === 'draft').length,
        pending: offers.filter(o => o.status === 'pending').length,
        approved: offers.filter(o => o.status === 'approved').length
      });
      
      setRecentOffers(offers.slice(0, 5));
    } catch (error) {
      console.error('Veri yüklenemedi:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const getStatusBadge = (status) => {
    const badges = {
      draft: { text: 'Taslak', class: 'status-draft' },
      pending: { text: 'Onay Bekliyor', class: 'status-pending' },
      approved: { text: 'Onaylandı', class: 'status-approved' },
      sent: { text: 'Gönderildi', class: 'status-sent' },
      rejected: { text: 'Reddedildi', class: 'status-rejected' }
    };
    const badge = badges[status] || { text: status, class: '' };
    return <span className={`status-badge ${badge.class}`}>{badge.text}</span>;
  };

  return (
    <div className="dashboard-page">
      <button className="logout-button" onClick={handleLogout}>
        🚪 Çıkış Yap
      </button>

      <div className="dashboard-header">
        <h1>Hoş Geldiniz, {user?.fullName || 'Kullanıcı'}</h1>
        <p>Teklif Yönetim Sistemi Dashboard</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-header">
            <span className="stat-card-title">Toplam Teklif</span>
            <div className="stat-icon">📊</div>
          </div>
          <div className="stat-value">{stats.total}</div>
          <div className="stat-label">Tüm teklifler</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <span className="stat-card-title">Taslak</span>
            <div className="stat-icon">📝</div>
          </div>
          <div className="stat-value">{stats.draft}</div>
          <div className="stat-label">Taslak teklifler</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <span className="stat-card-title">Onay Bekliyor</span>
            <div className="stat-icon">⏳</div>
          </div>
          <div className="stat-value">{stats.pending}</div>
          <div className="stat-label">Onay bekleyenler</div>
        </div>

        <div className="stat-card">
          <div className="stat-card-header">
            <span className="stat-card-title">Onaylanan</span>
            <div className="stat-icon">✅</div>
          </div>
          <div className="stat-value">{stats.approved}</div>
          <div className="stat-label">Onaylı teklifler</div>
        </div>
      </div>

      <div className="quick-actions">
        <h2 className="section-title">Hızlı İşlemler</h2>
        <div className="actions-grid">
          <div className="action-button" onClick={() => navigate('/offers/create')}>
            <span className="action-icon">➕</span>
            Yeni Teklif Oluştur
          </div>
          <div className="action-button" onClick={() => navigate('/offers')}>
            <span className="action-icon">📋</span>
            Tüm Teklifler
          </div>
          <div className="action-button" onClick={() => navigate('/customers')}>
            <span className="action-icon">👥</span>
            Müşteriler
          </div>
          <div className="action-button" onClick={() => navigate('/products')}>
            <span className="action-icon">📦</span>
            Ürünler
          </div>
          {user?.role === 'admin' && (
            <>
              <div className="action-button" onClick={() => navigate('/pending-offers')}>
                <span className="action-icon">⏰</span>
                Onay Bekleyenler
              </div>
              <div className="action-button" onClick={() => navigate('/users')}>
                <span className="action-icon">👤</span>
                Kullanıcılar
              </div>
            </>
          )}
        </div>
      </div>

      <div className="recent-offers">
        <h2 className="section-title">Son Teklifler</h2>
        <div className="offers-table">
          <table>
            <thead>
              <tr>
                <th>Teklif No</th>
                <th>Müşteri</th>
                <th>Tarih</th>
                <th>Tutar</th>
                <th>Durum</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recentOffers.map(offer => (
                <tr key={offer.id}>
                  <td><strong>{offer.offer_number}</strong></td>
                  <td>{offer.customer_name}</td>
                  <td>{new Date(offer.offer_date).toLocaleDateString('tr-TR')}</td>
                  <td><strong>{parseFloat(offer.total).toFixed(2)} {offer.currency}</strong></td>
                  <td>{getStatusBadge(offer.status)}</td>
                  <td>
                    <button 
                      className="action-button" 
                      style={{padding: '8px 16px', fontSize: '14px'}}
                      onClick={() => navigate(`/offers/${offer.id}`)}
                    >
                      Görüntüle →
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
